import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { TFunction } from 'i18next';
import { unitPriceFields } from 'pages/Products/ProductConstants';
import { GroupPrice } from 'types/MerchantTypes';

export const exportProductInformationExcel = async (
  t: TFunction,
  products: any[],
  StoresTextMap: Record<string, string>,
  groupPrice: GroupPrice[]
) => {
  const now = new Date();
  const formattedDate = `${now.getFullYear()}${String(
    now.getMonth() + 1
  ).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}`;

  const workbook = new ExcelJS.Workbook();
  // const worksheet = workbook.addWorksheet('Products');
  const worksheet = workbook.addWorksheet();

  // worksheet.columns = [
  //   { header: 'Branch code', key: 'branch_code', width: 25 },
  //   { header: 'Item ID', key: 'item_id_number', width: 10 },
  //   { header: 'Barcode ID', key: 'barcode', width: 20 },
  //   { header: 'Category', key: 'category_name', width: 20 },
  //   { header: 'Item Name', key: 'name', width: 25 },
  //   { header: 'Cost Price', key: 'cost_price', width: 15 },
  //   ...groupPrice.map((group, index) => ({
  //     header: group.name,
  //     key: unitPriceFields[index]?.fieldName || `unit_price${index}`,
  //     width: 15,
  //   })),
  //   { header: 'Quantity Balance', key: 'quantity', width: 12 },
  //   { header: 'Reorder Level', key: 'quantity_notify', width: 12 },
  //   { header: 'Description', key: 'description', width: 12 },
  //   { header: 'Supplier', key: 'supplier', width: 12 },
  //   { header: 'Sales Tax', key: 'vat', width: 10 },
  // ];
  // worksheet.columns = [
  //   { header: 'Branch code', key: 'branch_code' },
  //   { header: 'Item ID', key: 'item_id_number' },
  //   { header: 'Barcode ID', key: 'barcode' },
  //   { header: 'Category', key: 'category_name' },
  //   { header: 'Item Name', key: 'name' },
  //   { header: 'Cost Price', key: 'cost_price' },
  //   ...groupPrice.map((group, index) => ({
  //     header: group.name,
  //     key: unitPriceFields[index]?.fieldName || `unit_price${index}`,
  //   })),
  //   { header: 'Quantity Balance', key: 'quantity' },
  //   { header: 'Reorder Level', key: 'quantity_notify' },
  //   { header: 'Description', key: 'description' },
  //   { header: 'Supplier', key: 'supplier' },
  //   { header: 'Sales Tax', key: 'vat' },
  // ];
  worksheet.columns = [
    { header: t('Branch code'), key: 'branch_code' },
    // { header: t('Item ID'), key: 'item_id_number', style: { numFmt: '@' } }, //? text format
    // {
    //   header: t('Item ID'),
    //   key: 'item_id_number',
    //   style: { numFmt: '0000000' },
    // },
    {
      header: t('Item ID'),
      key: 'code',
    },
    { header: t('Barcode ID'), key: 'barcode' },
    { header: t('Category'), key: 'category_name' },
    { header: t('Item Name'), key: 'name' },
    {
      header: t('Cost Price'),
      key: 'cost_price',
      style: { numFmt: '#,##0.00' },
    },
    ...groupPrice.map((group, index) => ({
      header: group.name,
      key: unitPriceFields[index]?.fieldName || `unit_price${index}`,
      style: { numFmt: '#,##0.00' },
    })),
    {
      header: t('Quantity Balance'),
      key: 'quantity',
      style: { numFmt: '#,##0.00' },
    },
    {
      header: t('Reorder Level'),
      key: 'quantity_notify',
      style: { numFmt: '#,##0.00' },
    },
    { header: t('Product Description'), key: 'description' },
    { header: t('Supplier'), key: 'supplier' },
    { header: t('Sales Tax'), key: 'vat' },
  ];

  products.forEach((product) => {
    const rowData: Record<string, any> = {
      branch_code: StoresTextMap[product.store_id] || product.store_id,
      code: product.code,
      // item_id_number: product.item_id_number,
      // item_id_number: String(product.item_id_number).padStart(7, '0'), //? text format
      barcode: product.barcode,
      category_name: product.category_name,
      name: product.name,
      cost_price: product.cost_price,
      quantity: product.quantity,
      quantity_notify: product.quantity_notify,
      description: product.description,
      supplier: product.supplier,
      vat: product.vat,
    };

    groupPrice.forEach((_, index) => {
      const fieldName =
        unitPriceFields[index]?.fieldName || `unit_price${index}`;
      rowData[fieldName] = product[fieldName];
    });

    worksheet.addRow(rowData);
  });

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), `export_items_${formattedDate}.xlsx`);
};
